import React, { useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import FeedBackModal from "../FeedBackModal/FeedBackModal"

const PatientFeedback = (props) => {
    const [modalVisible, setModalVisible] = useState(false)
    const { selectedLanguage } = props
    const showModal = () => {
        setModalVisible(true)
    }

    const handleCancel = () => {
        setModalVisible(false)
    }
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000
    }
    return (
        <div className="patient-feedback-main">
            <div className="">
                <Slider {...settings} className="feed-back-slider-main">
                    <div>
                        <span className="feedback-quotes">“</span>
                        <p className="feedback-slide-text">
                            {selectedLanguage?.txt_very_carefull_dentist}
                            <br />
                            {selectedLanguage?.txt_hege_bjorke}
                        </p>
                    </div>
                    <div>
                        <span className="feedback-quotes">“</span>
                        <p className="feedback-slide-text">
                            {selectedLanguage?.txt_sehr_netter_arzt}
                            <br />
                            {selectedLanguage?.txt_christian_zimmer}
                        </p>
                    </div>
                    <div>
                        <span className="feedback-quotes">“</span>
                        <p className="feedback-slide-text">
                            {selectedLanguage?.txt_very_good_quality}
                            <br />
                            {selectedLanguage?.txt_jane_vandepoel}
                        </p>
                    </div>
                    <div>
                        <span className="feedback-quotes">“</span>
                        <p className="feedback-slide-text">
                            {selectedLanguage?.txt_hallo_wurde_mich_mal}
                            <br />
                            {selectedLanguage?.txt_schlee}
                        </p>
                    </div>
                    <div>
                        <span className="feedback-quotes">“</span>
                        <p className="feedback-slide-text">
                            {selectedLanguage?.txt_die_profesinelle_zahnreinigung}
                            <br />
                            {selectedLanguage?.txt_manuela_landgraf}
                        </p>
                    </div>
                </Slider>
                <div className="patient-feedback-btn-div">
                    <button className="card-section-2-btn" onClick={showModal}>{selectedLanguage?.txt_patient_feedback}</button>
                </div>
            </div>
            <FeedBackModal visible={modalVisible} onCancel={handleCancel} {...props} />
        </div>
    )
}

export default PatientFeedback